import { ApiService } from '@/api';
import { NewSeason, Season } from '@/models';

export class SeasonsApi {
  private readonly baseUrl = '/api/seasons';

  public async fetchCurrentSeason(): Promise<Season> {
    const response = await ApiService.get(`${this.baseUrl}/current`);

    return response.json();
  }

  public async fetchAllSeasons(): Promise<Season[]> {
    const response = await ApiService.get(`${this.baseUrl}`);

    return response.json();
  }

  public async addSeason(season: NewSeason): Promise<void> {
    const response = await ApiService.post(`${this.baseUrl}`, season);

    return response.json();
  }

  public async editSeason(season: NewSeason): Promise<void> {
    const response = await ApiService.put(`${this.baseUrl}`, season);

    return response.json();
  }
}
